import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isChecked'
})
export class IsCheckedPipe implements PipeTransform {

  constructor(
  ) {}

  transform(value: any): string {
    const icon = value === true || value === 1 ? 'check' : 'ban';
    return '<i class="pi pi-' + icon + '"></i>';
  }

}
